var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "button",
      {
        staticClass: "btn",
        staticStyle: { padding: "0.5rem" },
        on: {
          click: function ($event) {
            return _vm.openModal()
          },
        },
      },
      [_c("i", { staticClass: "fa-regular fa-gear" })]
    ),
    _vm._v(" "),
    _vm.isModalOpen
      ? _c("div", { staticClass: "modal-container" }, [
          _c(
            "div",
            { staticClass: "modal-content" },
            [
              _c("h1", [
                _vm._v("Configure: " + _vm._s(_vm.config.title)),
                _c("i", {
                  staticClass: "fa-regular fa-xmark",
                  on: {
                    click: function ($event) {
                      return _vm.closeModal()
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "small",
                { staticStyle: { color: "#717182", "font-weight": "normal" } },
                [_vm._v("Adjust the parameters for this reconciliation rule.")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "info-container" }, [
                _c("i", {
                  staticClass: "fa-regular fa-circle-info",
                  staticStyle: { color: "#1c398e" },
                }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.config.description))]),
              ]),
              _vm._v(" "),
              _vm._l(
                Object.entries(_vm.newRules.param),
                function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticStyle: {
                        display: "grid",
                        "background-color": "#fbf9fa !important",
                        padding: "1rem",
                        "border-radius": ".625rem",
                        margin: "1rem 0rem",
                        "row-gap": "0.5rem",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                            "justify-content": "space-between",
                          },
                        },
                        [
                          _c("div", { staticStyle: { display: "grid" } }, [
                            _c(
                              "span",
                              { staticStyle: { "font-weight": "bold" } },
                              [
                                _vm._v(
                                  _vm._s(
                                    item[0]
                                      .split("_")
                                      .map(function (e) {
                                        return (
                                          e.slice(0, 1).toUpperCase() +
                                          e.slice(1)
                                        )
                                      })
                                      .join(" ")
                                  )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            item[1].description
                              ? _c(
                                  "small",
                                  { staticStyle: { color: "#4a5565" } },
                                  [_vm._v(_vm._s(item[1].description))]
                                )
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          item[1].type == "boolean"
                            ? _c("div", [
                                _c(
                                  "div",
                                  {
                                    style: {
                                      display: "flex",
                                      "justify-content": item[1].value
                                        ? "end"
                                        : "left",
                                      "border-radius": "50px",
                                      height: "1rem",
                                      width: "2rem",
                                      "background-color": item[1].value
                                        ? "black"
                                        : "gray",
                                    },
                                    on: {
                                      click: function () {
                                        return (item[1].value = !item[1].value)
                                      },
                                    },
                                  },
                                  [
                                    _c("div", {
                                      staticStyle: {
                                        "border-radius": "50px",
                                        width: "1rem",
                                        height: "1rem",
                                        "background-color": "white",
                                      },
                                    }),
                                  ]
                                ),
                              ])
                            : item[1].type == "number"
                            ? _c("div", [
                                _c("input", {
                                  staticClass: "filter-item-content",
                                  attrs: {
                                    type: "number",
                                    placeholder: item[1].value,
                                  },
                                  on: {
                                    input: function (event) {
                                      return (item[1].value =
                                        event.target.value)
                                    },
                                  },
                                }),
                              ])
                            : _c(
                                "div",
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "filter-item-content d-flex justify-content-between py-2 px-3",
                                      attrs: {
                                        id: item[0] + "-picker-link",
                                        href: "#",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "fixed-span-size" },
                                        [_vm._v(_vm._s(item[1].value))]
                                      ),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass: "fa-light fa-chevron-down",
                                        attrs: {
                                          size: "17px",
                                          id: "page-chevron",
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-popover",
                                    {
                                      attrs: {
                                        target: item[0] + "-picker-link",
                                        triggers: "focus",
                                        placement: "bottom",
                                        "custom-class": "popover",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        _vm._l(
                                          item[1].options,
                                          function (option, index) {
                                            return _c(
                                              "span",
                                              {
                                                key: index,
                                                class: [
                                                  "popover-option",
                                                  {
                                                    "popover-option-selected":
                                                      option == item[1].value,
                                                  },
                                                ],
                                                on: {
                                                  click: function () {
                                                    return (item[1].value =
                                                      option)
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(option) +
                                                    "\n                "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                        ]
                      ),
                      _vm._v(" "),
                      item[1].example
                        ? _c("small", { staticStyle: { color: "#4a5565" } }, [
                            _c("small", { staticStyle: { color: "#155dfc" } }, [
                              _vm._v("Example:"),
                            ]),
                            _vm._v(" " + _vm._s(item[1].example)),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      item[1].impact
                        ? _c("small", { staticStyle: { color: "#4a5565" } }, [
                            _c("small", { staticStyle: { color: "#e17100" } }, [
                              _vm._v("Impact:"),
                            ]),
                            _vm._v(" " + _vm._s(item[1].impact)),
                          ])
                        : _vm._e(),
                    ]
                  )
                }
              ),
              _vm._v(" "),
              _c("div", { staticClass: "modal-content-buttons" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn-outline-light btn",
                    on: {
                      click: function ($event) {
                        return _vm.closeModal()
                      },
                    },
                  },
                  [_vm._v("Cancel")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn-outline btn-dark",
                    on: {
                      click: function ($event) {
                        return _vm.saveChanges()
                      },
                    },
                  },
                  [_vm._v("Apply Changes")]
                ),
              ]),
            ],
            2
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }